module.exports = __webpack_public_path__ + "img/DSC_3265.f015a23a.jpg";